export enum BudgetAvailability {
  Available = 'Available',
  NotAvailable = 'Not available',
  DontKnow = "Don't know"
}
